import React from "react";

import { Chip } from "@performyard/py-components";

import { type TranscriptBannerStateKind, useTranscriptBannerState } from "../hooks";

// States that surface a header chip. "too_long" shows a banner but no chip; "none" shows nothing.
const CHIP_BY_STATE: Partial<Record<TranscriptBannerStateKind, { label: string; color: "primary" | "red" }>> = {
	awaiting: { label: "Scheduled", color: "primary" },
	// "delayed" pre-empts "awaiting", so without its own row the header would lose the chip entirely —
	// and the section renders collapsed by default, making the chip the only visible signal.
	delayed: { label: "Delayed", color: "primary" },
	failed: { label: "Not Retrieved", color: "red" },
	pmi: { label: "Automatic Retrieval Off", color: "primary" },
	disconnected: { label: "Automatic Retrieval Off", color: "primary" },
	discoverability: { label: "Automatic Retrieval Off", color: "primary" },
};

/** Status chip shown in the Meeting Transcript section header (creator-only; collapsed and expanded). */
const TranscriptStatusChip = (): React.ReactElement | null => {
	const state = useTranscriptBannerState();
	const chip = CHIP_BY_STATE[state];
	if (!chip) return null;
	return <Chip size={24} color={chip.color} label={chip.label} />;
};

export default TranscriptStatusChip;
